import { ClipboardSignature } from "lucide-react";

const manifest = {
  key: "proposal_approvals_management",
  isFreeModule: false,
  isPurchasable: true,
  icon: ClipboardSignature,
  names: {
    plan: {
      en: "Proposal Approval Management",
      ar: "إدارة اعتماد طلبات وموافقات العروض",
    },
    dashboard: {
      en: "Proposal Approval Management",
      ar: "إدارة اعتماد طلبات وموافقات العروض",
    },
  },
  defaultPath: "/proposal-approvals",
  matchers: [
    /^\/proposal-approvals(?:\/|$)/,
    /^\/incoming-invitations(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__proposal_approvals__",
      children: [
        {
          label: t("dashboard"),
          path: "/proposal-approvals",
          permissions: ["accept_reject_invitations"],
        },
        {
          label: t("incomingInvitations"),
          path: "/incoming-invitations",
          permissions: ["accept_reject_invitations"],
        },
      ],
    },
  ],
};

export default manifest;
